"use client"

import { useState } from "react"
import { ChevronDown, ChevronUp, User, Users, Loader } from 'lucide-react'

const Contacts = ({ contactsData, onContactSelect, currentUserId, isLoading }) => {
  const [expandedClass, setExpandedClass] = useState(null)

  const toggleExpand = (classId) => {
    setExpandedClass(expandedClass === classId ? null : classId)
  }

  const handleContactClick = (contact) => {
    onContactSelect(contact)
  }

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    )
  }

  // Add debugging to check what data is being received
  console.log("Contacts component received data:", contactsData)

  // Check if contactsData is a string (JSON) and parse it if needed
  let parsedData = contactsData
  if (typeof contactsData === 'string') {
    try {
      parsedData = JSON.parse(contactsData)
      console.log("Parsed contacts data:", parsedData)
    } catch (e) {
      console.error("Error parsing contacts data:", e)
    }
  }

  if (!parsedData || parsedData.length === 0) {
    return <div className="p-4 text-center text-gray-500">No contacts available.</div>
  }

  return (
    <div className="space-y-4 p-4">
      {parsedData.map((classData, index) => {
        const classId = classData.id || `class-${index}`
        const isExpanded = expandedClass === classId

        // Skip classes with no students
        if (!classData.students || classData.students.length === 0) {
          return null
        }

        return (
          <div key={classId} className="border rounded-lg overflow-hidden shadow-sm">
            <button
              className="w-full flex justify-between items-center p-4 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out"
              onClick={() => toggleExpand(classId)}
            >
              <span className="font-semibold text-gray-800">
                {classData.subject} - Class {classData.classValue} {classData.section && `(${classData.section})`}
              </span>
              {isExpanded ? (
                <ChevronUp size={20} className="text-gray-600" />
              ) : (
                <ChevronDown size={20} className="text-gray-600" />
              )}
            </button>
            {isExpanded && (
              <div className="p-4 bg-gray-50">
                <h3 className="font-bold text-lg mb-2 flex items-center text-gray-700">
                  <Users className="mr-2 text-green-500" /> Students ({classData.students.length})
                </h3>
                <ul className="space-y-2">
                  {classData.students.map((student) => (
                    <li
                      key={student.id}
                      className="flex items-center space-x-3 bg-white p-3 rounded-lg cursor-pointer hover:bg-gray-100 transition duration-150 ease-in-out"
                      onClick={() =>
                        handleContactClick({ id: student.id, name: student.name, type: "student" })
                      }
                    >
                      <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                        <User className="w-6 h-6 text-green-600" />
                      </div>
                      <div className="flex-1">
                        <span className="font-medium text-gray-800">{student.name}</span>
                        {student.email && (
                          <p className="text-xs text-gray-500">{student.email}</p>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Contacts